(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[510],{

/***/ 944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7814);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3024);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9417);






var Icon = function(_param) {
    var name = _param.name, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "name"
    ]);
    switch(name){
        case "rss":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faRss */ .Fwd
            }, rest));
        case "github":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faGithub */ .zhw
            }, rest));
        case "instagram":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faInstagram */ .Zzi
            }, rest));
        case "quora":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faQuora */ .lLR
            }, rest));
        case "twitter":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faXTwitter */ .NCc
            }, rest));
        case "linkedin":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faLinkedin */ .D9H
            }, rest));
        case "facebook":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faFacebook */ .neY
            }, rest));
        case "whatsapp":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faWhatsapp */ .VHX
            }, rest));
        case "sun":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faSun */ .enB
            }, rest));
        case "moon":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faMoon */ .DBF
            }, rest));
        default:
            return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 3510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/Footer.module.css
var Footer_module = __webpack_require__(3952);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./data/socials.js
var SOCIALS = [
    {
        icon: "github",
        href: "https://www.github.com/niemenjoki",
        ariaLabel: "Github"
    },
    {
        icon: "twitter",
        href: "https://x.com/niemenjoki",
        ariaLabel: "Twitter"
    },
    {
        icon: "linkedin",
        href: "https://fi.linkedin.com/in/joonasniemenjoki",
        ariaLabel: "LinkedIn"
    },
    {
        icon: "instagram",
        href: "https://www.instagram.com/niemenjoki.dev",
        ariaLabel: "Instagram"
    },
    {
        icon: "quora",
        href: "https://fi.quora.com/profile/Joonas-Niemenjoki",
        ariaLabel: "Quora"
    },
    {
        onlyForLanguage: "fi",
        icon: "rss",
        href: "https://niemenjoki.fi/rss-fi.xml",
        ariaLabel: "RSS-Sy\xf6te"
    },
    {
        onlyForLanguage: "en",
        icon: "rss",
        href: "https://niemenjoki.fi/rss-en.xml",
        ariaLabel: "RSS "
    }, 
];

// EXTERNAL MODULE: ./components/Icon.js
var Icon = __webpack_require__(944);
;// CONCATENATED MODULE: ./components/Socials.js



var Socials = function(param) {
    var language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: SOCIALS.filter(function(social) {
            if (social.onlyForLanguage && social.onlyForLanguage !== language) return false;
            return true;
        }).map(function(social) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: social.icon + "-icon",
                href: social.href,
                target: "_blank",
                rel: "noreferrer",
                "aria-label": social.ariaLabel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: social.icon
                })
            }, social.icon);
        })
    });
};
/* harmony default export */ var components_Socials = (Socials);

;// CONCATENATED MODULE: ./components/Footer.js




var Footer = function(param) {
    var language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (Footer_module_default()).Footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).Left,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (Footer_module_default()).Links,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "en" ? "/blog" : "/blogi",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "en" ? "Blog" : "Blogi"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "en" ? "/projects" : "/projektit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "en" ? "Projects" : "Projektit"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (Footer_module_default()).ProjectLinks,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: language === "en" ? "/projects/compress-create-react-app" : "/projektit/compress-create-react-app",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "- compress-create-react-app"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "en" ? "/about" : "/tietoa",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "en" ? "About" : "Tietoa"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "en" ? "/privacy" : "/tietosuoja",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "en" ? "Privacy" : "Tietosuoja"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).NoMobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "\xa9 2020-",
                                    new Date().getFullYear(),
                                    " Joonas Niemenjoki.",
                                    " ",
                                    language === "en" ? "Code and content are" : "Koodi ja sis\xe4lt\xf6 on",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://github.com/jnsjknn/website/blob/master/LICENSE.md",
                                        target: "_blank",
                                        rel: "license noopener noreferrer",
                                        children: language === "en" ? "licensed" : "lisensoitu"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            marginTop: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                children: language === "en" ? "The views and opinions expressed on this website are my own and do not represent the views or opinions of my employer or any other parties." : "Sivustolla esitetyt n\xe4kemykset ja mielipiteet ovat omiani eiv\xe4tk\xe4 edusta ty\xf6nantajani tai mink\xe4\xe4n muun sidosryhm\xe4n kantoja tai n\xe4kemyksi\xe4."
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Footer_module_default()).Right,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (Footer_module_default()).Links,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                rel: "noreferrer",
                                href: "https://github.com/jnsjknn/website",
                                children: language === "en" ? "Source code" : "L\xe4hdekoodi"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Footer_module_default()).Socials,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Socials, {
                                language: language
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).Mobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "\xa9 2020-",
                            new Date().getFullYear(),
                            " Joonas Niemenjoki"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            language === "en" ? "Code and content are" : "Koodi ja sis\xe4lt\xf6 on",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://github.com/jnsjknn/website/blob/master/LICENSE.md",
                                target: "_blank",
                                rel: "license noopener noreferrer",
                                children: language === "en" ? "licensed" : "lisensoitu"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: "10px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: language === "en" ? "The views and opinions expressed on this website are my own and do not represent the views or opinions of my employer or any other parties." : "Sivustolla esitetyt n\xe4kemykset ja mielipiteet ovat omiani eiv\xe4tk\xe4 edusta ty\xf6nantajani tai mink\xe4\xe4n muun sidosryhm\xe4n kantoja tai n\xe4kemyksi\xe4."
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./hooks/useToggle.js
var useToggle = __webpack_require__(981);
// EXTERNAL MODULE: ./styles/Navbar.module.css
var Navbar_module = __webpack_require__(1585);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./styles/ThemeToggler.module.css
var ThemeToggler_module = __webpack_require__(1088);
var ThemeToggler_module_default = /*#__PURE__*/__webpack_require__.n(ThemeToggler_module);
;// CONCATENATED MODULE: ./components/ThemeToggler.js





var ThemeToggler = function(param) {
    var style = param.style, props = param.props;
    var ref = (0,react.useState)(false), isDarkMode = ref[0], setDarkMode = ref[1];
    (0,react.useEffect)(function() {
        var modeInStorage = localStorage.getItem("darkMode");
        if (modeInStorage) {
            setDarkMode(JSON.parse(modeInStorage));
        } else {
            setDarkMode(window.matchMedia("(prefers-color-scheme: dark)").matches);
        }
        document.body.classList.toggle("dark", isDarkMode);
    }, [
        isDarkMode
    ]);
    var handleClick = function() {
        localStorage.setItem("darkMode", JSON.stringify(!isDarkMode));
        setDarkMode(!isDarkMode);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, (0,_object_spread/* default */.Z)({
        name: isDarkMode ? "sun" : "moon",
        className: (ThemeToggler_module_default()).ThemeToggler,
        onClick: handleClick
    }, props));
};
/* harmony default export */ var components_ThemeToggler = (ThemeToggler);

// EXTERNAL MODULE: ./styles/Toggler.module.css
var Toggler_module = __webpack_require__(6355);
var Toggler_module_default = /*#__PURE__*/__webpack_require__.n(Toggler_module);
;// CONCATENATED MODULE: ./components/Toggler.js


var Toggler = function(param) {
    var drawerOpen = param.drawerOpen, clicked = param.clicked;
    var classList = [
        (Toggler_module_default()).Toggler
    ];
    if (drawerOpen) classList.push((Toggler_module_default()).IsOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: classList.join(" "),
        type: "button",
        onClick: clicked,
        "aria-label": "Navbar Toggler",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (Toggler_module_default()).TogglerBox,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Toggler_module_default()).TogglerInner
            })
        })
    });
};
/* harmony default export */ var components_Toggler = (Toggler);

;// CONCATENATED MODULE: ./components/Navbar.js









var Navbar = function(param) {
    var language = param.language, i18n = param.i18n;
    var router = (0,next_router.useRouter)();
    var navLinks = [
        {
            href: "".concat(language === "en" ? "/blog" : "/blogi"),
            text: "".concat(language === "en" ? "Blog" : "Blogi")
        },
        {
            href: "".concat(language === "en" ? "/projects" : "/projektit"),
            text: "".concat(language === "en" ? "Projects" : "Projektit")
        },
        {
            href: "".concat(language === "en" ? "/about" : "/tietoa"),
            text: "".concat(language === "en" ? "About" : "Tietoa")
        }, 
    ];
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isOpen = ref[0], toggleIsOpen = ref[1];
    var updateLanguagePreference = function(e, language) {
        e.preventDefault();
        var i18nHomePagePath = language === "en" ? "/" : "/en";
        var i18nTargetPath = i18n ? new URL(i18n).pathname : i18nHomePagePath;
        if (language === "en") {
            localStorage.setItem("languagePreference", "fi");
        } else {
            localStorage.setItem("languagePreference", "en");
        }
        router.push(i18nTargetPath);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (Navbar_module_default()).NavbarWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Navbar_module_default()).Navbar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Navbar_module_default()).Brand,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: language === "en" ? "/en" : "/",
                            children: "Joonas Niemenjoki"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: [
                            (Navbar_module_default()).Nav,
                            isOpen ? (Navbar_module_default()).Open : null
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Navbar_module_default()).Toggler,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Toggler, {
                                    drawerOpen: isOpen,
                                    clicked: toggleIsOpen
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (Navbar_module_default()).Drawer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: i18n ? new URL(i18n).pathname : language === "en" ? "/" : "/en",
                                            className: (Navbar_module_default()).LanguageToggler,
                                            onClick: function(e) {
                                                return updateLanguagePreference(e, language);
                                            },
                                            children: language === "en" ? "suomeksi" : "in English"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThemeToggler, {
                                            style: {
                                                fontSize: "28px"
                                            }
                                        })
                                    }),
                                    navLinks.map(function(link) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return toggleIsOpen(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Navbar_module_default()).NavButton,
                                                    children: link.text
                                                })
                                            })
                                        }, link.href);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (Navbar_module_default()).Socials,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Socials, {
                                            language: language
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Navbar_module_default()).Divider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    viewBox: "0 0 1200 120",
                    preserveAspectRatio: "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Navbar = (Navbar);

;// CONCATENATED MODULE: ./components/Layout.js







var Layout = function(param) {
    var title = param.title, description = param.description, i18n = param.i18n, language = param.language, children = param.children;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    (0,react.useEffect)(function() {
        document.documentElement.lang = language;
    }, [
        language
    ]);
    var handleRouteChange = function(url) {
        var ref;
        (ref = window.gtag) === null || ref === void 0 ? void 0 : ref.call(window, "config", "G-0448XXF0S0", {
            page_path: url
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, viewport-fit=cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    i18n && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        hrefLang: language === "en" ? "fi" : "en",
                        href: i18n
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://niemenjoki.fi".concat(router === null || router === void 0 ? void 0 : router.asPath)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: "/icons/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        href: "/icons/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#0e111b"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-0448XXF0S0",
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "analytics-loader",
                dangerouslySetInnerHTML: {
                    __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', 'G-0448XXF0S0', { page_path: window.location.pathname });\n            "
                },
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Navbar, {
                language: language,
                i18n: i18n
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {
                language: language
            })
        ]
    });
};
Layout.defaultProps = {
    title: "Joonas Niemenjoki",
    keywords: "engineering, development, web, javascript, automation, science",
    description: "Sharing the things I have learned with a focus on web development, engineering, and science!"
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useToggle = function(defaultValue) {
    var toggleValue = function toggleValue(value) {
        setValue(function(currentValue) {
            return typeof value === "boolean" ? value : !currentValue;
        });
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue), value = ref[0], setValue = ref[1];
    return [
        value,
        toggleValue
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 3952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__qt1iW","Links":"Footer_Links__0dRf0","ProjectLinks":"Footer_ProjectLinks__QfyLI","Mobile":"Footer_Mobile__kLtLa","NoMobile":"Footer_NoMobile__YL9dL","Socials":"Footer_Socials__cwS8O"};

/***/ }),

/***/ 1585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Navbar_Nav__2OWKb","Brand":"Navbar_Brand__18mRb","Open":"Navbar_Open__ADhVo","Socials":"Navbar_Socials__PNZPM","Drawer":"Navbar_Drawer__n3kLV","NavButton":"Navbar_NavButton__j8LeH","LanguageToggler":"Navbar_LanguageToggler__Fa_4r","Toggler":"Navbar_Toggler__jd9Ep","NavbarWrapper":"Navbar_NavbarWrapper__kNEJi","Navbar":"Navbar_Navbar__gJ05l","Divider":"Navbar_Divider__6JDvK"};

/***/ }),

/***/ 1088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ThemeToggler":"ThemeToggler_ThemeToggler__Kc3g4"};

/***/ }),

/***/ 6355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Toggler":"Toggler_Toggler__6wlCL","IsOpen":"Toggler_IsOpen__Umycb","TogglerInner":"Toggler_TogglerInner__8jI2m","TogglerBox":"Toggler_TogglerBox__JAONH"};

/***/ })

}]);